"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDisconnectedAdAccount = void 0;
var isDisconnectedAdAccount = function (account) { var _a; return account.status === 'ACTIVE' && ((_a = account.details) === null || _a === void 0 ? void 0 : _a.status) === 'NO_ACCESS'; };
exports.isDisconnectedAdAccount = isDisconnectedAdAccount;
